/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardGrantResponse
 */
export interface RewardGrantResponse {
    /**
     * 
     * @type {string}
     * @memberof RewardGrantResponse
     */
    catalogItemId: string;
    /**
     * 
     * @type {number}
     * @memberof RewardGrantResponse
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardGrantResponse
     */
    giftCardAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof RewardGrantResponse
     */
    durationAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof RewardGrantResponse
     */
    campaignId?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardGrantResponse
     */
    surfaceId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RewardGrantResponse
     */
    autoClaim?: boolean;
}

/**
 * Check if a given object implements the RewardGrantResponse interface.
 */
export function instanceOfRewardGrantResponse(value: object): value is RewardGrantResponse {
    if (!('catalogItemId' in value) || value['catalogItemId'] === undefined) return false;
    return true;
}

export function RewardGrantResponseFromJSON(json: any): RewardGrantResponse {
    return RewardGrantResponseFromJSONTyped(json, false);
}

export function RewardGrantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardGrantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'catalogItemId': json['catalogItemId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'giftCardAmount': json['giftCardAmount'] == null ? undefined : json['giftCardAmount'],
        'durationAmount': json['durationAmount'] == null ? undefined : json['durationAmount'],
        'campaignId': json['campaignId'] == null ? undefined : json['campaignId'],
        'surfaceId': json['surfaceId'] == null ? undefined : json['surfaceId'],
        'autoClaim': json['autoClaim'] == null ? undefined : json['autoClaim'],
    };
}

export function RewardGrantResponseToJSON(json: any): RewardGrantResponse {
    return RewardGrantResponseToJSONTyped(json, false);
}

export function RewardGrantResponseToJSONTyped(value?: RewardGrantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'catalogItemId': value['catalogItemId'],
        'amount': value['amount'],
        'giftCardAmount': value['giftCardAmount'],
        'durationAmount': value['durationAmount'],
        'campaignId': value['campaignId'],
        'surfaceId': value['surfaceId'],
        'autoClaim': value['autoClaim'],
    };
}

